/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RelatedDevice,
  RelatedDevice$inboundSchema,
  RelatedDevice$Outbound,
  RelatedDevice$outboundSchema,
} from "./relateddevice.js";

/**
 * A section of related devices
 */
export type RelatedDeviceSection = {
  /**
   * The devices to display in the section
   */
  devices: Array<RelatedDevice>;
  /**
   * The title of the section
   */
  title?: string | undefined;
};

/** @internal */
export const RelatedDeviceSection$inboundSchema: z.ZodType<
  RelatedDeviceSection,
  z.ZodTypeDef,
  unknown
> = z.object({
  devices: z.array(RelatedDevice$inboundSchema),
  title: types.optional(types.string()),
});
/** @internal */
export type RelatedDeviceSection$Outbound = {
  devices: Array<RelatedDevice$Outbound>;
  title?: string | undefined;
};

/** @internal */
export const RelatedDeviceSection$outboundSchema: z.ZodType<
  RelatedDeviceSection$Outbound,
  z.ZodTypeDef,
  RelatedDeviceSection
> = z.object({
  devices: z.array(RelatedDevice$outboundSchema),
  title: z.string().optional(),
});

export function relatedDeviceSectionToJSON(
  relatedDeviceSection: RelatedDeviceSection,
): string {
  return JSON.stringify(
    RelatedDeviceSection$outboundSchema.parse(relatedDeviceSection),
  );
}
export function relatedDeviceSectionFromJSON(
  jsonString: string,
): SafeParseResult<RelatedDeviceSection, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RelatedDeviceSection$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RelatedDeviceSection' from JSON`,
  );
}
